import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'jhi-selection-count',
    standalone: true,
    imports: [
        NgbPopover,
        FormsModule,
        TranslateModule
    ],
    templateUrl: './selection-count.component.html',
    styleUrl: './selection-count.component.scss'
})
export class SelectionCountComponent {

    selectAllUniqueId: string;


    @Input() isSelectAll: boolean;
    @Input() selectedItemsSize: number;
    @Output() deselectAction: EventEmitter<any> = new EventEmitter();
    @Output() selectAllAction: EventEmitter<boolean> = new EventEmitter();
    @Input() showSelectAll: boolean = false;
    @Input() totalItemsSize!: number;

    constructor() {
        // Generate a unique ID when component is created
        this.selectAllUniqueId = 'selectAll_' + Math.random().toString(36).substring(2, 9);

    }

    deselectAll() {
        if (this.deselectAction) {
            this.deselectAction.emit();
        }
        this.isSelectAll = false;
        this.selectAllChanged();
    }

    selectAllChanged() {
        if (this.selectAllAction) {
            this.selectAllAction.emit(this.isSelectAll);
        }
    }
}
